import type { OnboardingStepConfig } from '../types';

export const calcStepsCount = (
  onboarding: OnboardingStepConfig[]
): number | null => {
  return (
    onboarding.reduce((acc, curr) => {
      if (curr.steps.length) {
        const maxDisplayStep = Math.max(
          ...curr.steps.map(({ displayIndex }) => displayIndex ?? 0)
        );
        return acc < maxDisplayStep ? maxDisplayStep : acc;
      }
      return acc;
    }, 0) || null
  );
};
